import { Injectable } from "@angular/core";
import { MatPaginatorIntl } from '@angular/material/paginator';
@Injectable()
export class MatPaginatorIntlFr extends MatPaginatorIntl {
  itemsPerPageLabel = 'Lectures par page';
  nextPageLabel = 'Page Suivante';
  previousPageLabel = 'Page Précedente';
  lastPageLabel = 'Dernière Page';
  firstPageLabel = 'Première Page';

  getRangeLabel = function (page: number, pageSize: number, length: number): string {
    length = Math.max(length, 0);
    const startIndex = page * pageSize + 1;
    const endIndex = startIndex <= length ? Math.min(startIndex + pageSize - 1, length) : startIndex + pageSize - 1;
    return startIndex + " - " + endIndex + " sur " + length;
  }
}
